import React from 'react'

export const Error404 = () => {
  return (
    <div>404</div>
  )
}
